import { ACCOUNT_ROLES } from '../report/model'
import { type RatioData } from './model'

/**
 * Column key for a custom ratio. Always the ratio id, so two stage counts divide as pile totals.
 * Pipeline-history intersection stays on widget ratio fields (`ratio|account|S…|count|account|S…|count`).
 */
export function getRatioKpi(ratio: RatioData): string {
  return ratio.ratioId
}

/** Previous column key for two account KPIs. Saved views may still store this. */
export function toLegacyAccountRatioKpi(ratio: RatioData): string | undefined {
  if (ratio.type === 'formula') return
  if (!isAccountKpi(ratio.numerator) || !isAccountKpi(ratio.denominator)) return
  return `ratio|${ratio.numerator}|${ratio.denominator}`
}

export const isAccountKpi = (kpi: string): boolean => {
  if (kpi.startsWith('account|')) return true
  return ACCOUNT_ROLES.some((role) => kpi.startsWith(role))
}
